/* eslint-disable react/jsx-props-no-spreading */
import { Box, Typography, Alert, Grid2 } from "@mui/material";
import useTemplateTest from "../hooks/use-template-test";
import TestDataInput from "./test-data-input";
import TestResults from "./test-results";
import CustomizedAutocomplete from "../../shared/customized-autocomplete";

const TemplateTest = () => {
  const {
    templates,
    selectedTemplate,
    inputData,
    results,
    isLoading,
    error,
    setInputData,
    handleTemplateChange,
    handleSubmit,
  } = useTemplateTest();

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        Template Test
      </Typography>

      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <CustomizedAutocomplete
            options={templates || []}
            getOptionLabel={(option) => option.description}
            value={selectedTemplate}
            onChange={handleTemplateChange}
            label="Select Template"
            placeholder="Choose a template to test..."
            sx={{ mb: 2 }}
          />
          <TestDataInput
            value={inputData}
            onChange={setInputData}
            onSubmit={handleSubmit}
            disabled={!selectedTemplate || !inputData.trim() || isLoading}
            isLoading={isLoading}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 6 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <TestResults results={results} />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default TemplateTest;
